import {
  DASHBOARD_NOTIFICATION_LIST,
  DASHBOARD_SCHEDULED_NOTIFICATION_LIST,
  CHOOSE_USER_MODAL,
  DASHBOARD_USER_LIST_WITHOUT_ADMIN,
  DASHBOARD_NOTIFICATION_CREATE_MODAL,
  DASHBOARD_NOTIFICATION_VIEW_MODAL,
} from "DashboardOutreachAction";

export var DashboardNotificationList = (state = {}, action) => {
  if (action.type === DASHBOARD_NOTIFICATION_LIST) {
    return action.payload;
  }
  return state;
};

export var DashboardScheduledNotificationList = (state = {}, action) => {
  if (action.type === DASHBOARD_SCHEDULED_NOTIFICATION_LIST) {
    return action.payload;
  }
  return state;
};

export var ShowChooseUserModal = (state = false, action) => {
  if (action.type === CHOOSE_USER_MODAL) {
    return action.payload;
  }
  return state;
};

export var DashboardUserListWithoutAdmin = (state = {}, action) => {
  if (action.type === DASHBOARD_USER_LIST_WITHOUT_ADMIN) {
    return action.payload;
  }
  return state;
};

export var DashboardNotificationModal = (state = {}, action) => {
  if (action.type === DASHBOARD_NOTIFICATION_CREATE_MODAL) {
    return action.payload;
  }
  return state;
};

export var DashboardNotificationViewModal = (state = {}, action) => {
  if (action.type === DASHBOARD_NOTIFICATION_VIEW_MODAL) {
    return action.payload;
  }
  return state;
};
